<template>
  <div class="list-tag">
      <span v-for="(item, index) in filteredList" :key="index">
        {{ item[value] }}
      </span>
  </div>
</template>

<script>
export default {
  name: 'ListTag',
  props: {
    list: {
      type: Array,
      required: true
    },
    prop: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    keytag: {
      type: [String, Number]
    }
  },
  computed: {
    // 过滤列表，只保留符合 key 的项
    filteredList () {
      if (this.list && this.list.length > 0) {
        var info = this.list.filter(item => item[this.prop] === this.keytag)
        if (info && info.length > 0) {
          return info
        } else {
          return []
        }
      } else {
        return []
      }
    }
  }
}
</script>

<style scoped>
.list-tag ul {
  list-style-type: none;
  padding: 0;
}

.list-tag li {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/ListTag/index.vue